export * from "@pixi/constants"
export * from "@pixi/settings"
export * from "@pixi/display"
export * from "@pixi/core"
export * from "@pixi/app"
export * from "@pixi/sprite"
export * from "@pixi/loaders"

// Sprite, settings, filters, SCALE_MODES, Application, Container, Texture, Text, Loader

import * as utils from "@pixi/utils"
export { utils }

import {OutlineFilter} from "@pixi/filter-outline"
import {ColorMatrixFilter} from "@pixi/filter-color-matrix"
import {BlurFilter} from "@pixi/filter-blur"
export const filters = {ColorMatrixFilter, OutlineFilter, BlurFilter}

// export * from "@pixi/math"
// export * from "@pixi/runner"
// export * from "@pixi/ticker"

// Renderer plugins
import { Renderer } from "@pixi/core"
import { BatchRenderer } from "@pixi/core"
Renderer.registerPlugin("batch", BatchRenderer)

// Application plugins
import { Application } from "@pixi/app"
import { TickerPlugin } from "@pixi/ticker"
Application.registerPlugin(TickerPlugin)
